import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useCookies } from "react-cookie";
import { setCurrentRoute } from "../../redux/features/loginSlice";

import { setApiMessage } from "../../redux/features/globalApiMessageSlice";
import Layout from "../Layout";
import LandingComp from "./LandingComp";
import rightArrow from "../../assets/default/images/r-arrow.png";
import leftArrow from "../../assets/default/images/l-arrow.png";
import {
  // AddOrUpdateCollectionThunk,
  getAllCollectionsByAppUserIdlAndCompanyDivId,
} from "COLLECTION/collectionApi";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
function Landing() {
  let query = useQuery();
  const [cookies, setCookie, removeCookie] = useCookies();
  const { AllCollectedItems } = useSelector((state) => state.collection);

  const dispatch = useDispatch();
  let navigate = useNavigate();

  useEffect(() => {
    dispatch(setCurrentRoute("/home"));
    dispatch(setApiMessage(null));
    if (!AllCollectedItems?.length) {
      dispatch(getAllCollectionsByAppUserIdlAndCompanyDivId());
    }
    const clientId = query.get("clientId");
    setCookie("path", "/home", {
      path: "/",
      expires: new Date(Date.now() + 15000),
    });
  }, []);

  return (
    <Layout>
      <LandingComp rightArrow={rightArrow} leftArrow={leftArrow} />
    </Layout>
  );
}

export default Landing;
